import {BS2} from "../../BS2";
import {gsap} from "gsap";
import {BS2Statics} from "../../config/BS2Statics";
import {BS2GameAssets} from "../../BS2GameAssets";
import {WildSpinAnimName} from "../../server/BS2Data";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {WildSymbol} from "../../reels/WildSymbol";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BS2Symbol} from "../../reels/BS2Symbol";
import {BS2Sound} from "../../config/sound/BS2Sound";

export class BS2BottomStickyWildElement extends PIXI.Container {
    private _wildSpine: PIXI.spine.Spine;
    private _treeLockSprite: TimelineSprite;
    private _isLocked: boolean = true;
    private _starOverlay: PIXI.Sprite;
    private _winLineFlashTL: gsap.core.Timeline;
    private _noWinOverlay: PIXI.Sprite;
    private _glowFrameOverlay: PIXI.Sprite;
    private _glowFramePotentionWinAttenTL: gsap.core.Timeline;
    private _reelIdx: number;
    private _multiplier: PIXI.BitmapText;
    private _curMulti: number;
    private _wildFireAnimTl: gsap.core.Timeline | undefined;

    constructor(reelIdx: number) {
        super();
        this.name = "stickyWildTree_" + reelIdx;
        this._reelIdx = reelIdx;
        this._treeLockSprite = this.createTreeLockSprite();
        this._wildSpine = this.createWildSymSpine();
        this._noWinOverlay = this.createNoWinOverlay();
        this._glowFrameOverlay = this.createGlowFrameOverlay();
        this._glowFramePotentionWinAttenTL = this.potentialWinAttentionTimeline();
        this._starOverlay = this.createStarOverlay();
        this._winLineFlashTL = this.createWinLineFlashTL();
        this._multiplier = this.createMultiplier();
        this.setPosition(reelIdx);
        this.playWildAnimByName(WildSpinAnimName.IDLE_CANDLES, false, true);
        this.addChild(this._wildSpine, this._noWinOverlay, this._glowFrameOverlay, this._treeLockSprite);
    }


    public unLockStickyWildTree(durr: number, includeInTL: boolean, fromNormalBet: boolean, shouldPlayWildOpeningSound: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.treeLockSpriteOnCompCB();
                this.isVisible = false;
            }
        });
        if (!this.isLocked) {
            return tl;
        }
        tl.add(() => {
            this.isLocked = false;
        })
        tl.add([
            () => {
                if (shouldPlayWildOpeningSound) {
                    BS2.soundPlayer.playSound(BS2Sound.WILD_UNLOCK);
                }
            },
            this._treeLockSprite.getAnimation(),
            gsap.to(this._wildSpine, {duration: this._treeLockSprite.totalDuration, alpha: 0}),
            () => {
                if (!fromNormalBet ? true : !(BS2.model.buyFeatureName === BS2Statics.BOOSTED_BET_1 && this._reelIdx === 0)) {
                    const replaceData = BS2.reelView.reels[this._reelIdx].model.replaceWithNewSymbol(BS2Statics.BOT_STICKY_WILD_IDX_WITH_BUFFER, BS2Statics.SYMBOLS.W);
                    (<WildSymbol>replaceData.newSymbol.positionable).getStickyAnimation();
                    (<BS2Symbol>replaceData.oldSymbol.positionable).destroy();
                    // console.log(`replace in BSTE ${replaceData.oldSymbol.name}-->${replaceData.newSymbol.name}`)
                }
            }
        ]);
        tl.add(() => {
            this.resetStickyWildSpine();
            this.playWildAnimByName(WildSpinAnimName.IDLE_ALL, true, true);
        }, "<");
        return tl;
    }

    public removeStickyWild(durr: number, includeInTL: boolean, shouldPlayWildOpeningSound: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (!this.isVisible) {
            return tl;
        }
        tl.add(() => {
            this.isLocked = false;
            if (shouldPlayWildOpeningSound) {
                BS2.soundPlayer.playSound(BS2Sound.WILD_UNLOCK);
            }

        })
        if (includeInTL) {
            tl.to(this._wildSpine, {
                alpha: 0,
                duration: this._treeLockSprite.totalDuration
            });
            tl.add(this._treeLockSprite.getAnimation(), "<");
            tl.add(() => {
                this.isVisible = false;
                this.resetStickyWildSpine();
                this.treeLockSpriteOnCompCB();
            })
        } else {
            tl.add(() => {
                gsap.to(this._wildSpine, {
                    alpha: 0,
                    duration: this._treeLockSprite.totalDuration
                });
                this._treeLockSprite.getAnimation().add(() => {
                    this.isVisible = false;
                    this.resetStickyWildSpine();
                    this.treeLockSpriteOnCompCB();
                });
            })
        }


        return tl;
    }

    public lockStickyWildTree(durr: number, includeInTL: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.isLocked = true;
                this.isVisible = true;
                this.setMultiplier(1);
            }
        });
        if (this.isLocked) {
            return tl;
        }
        if (!includeInTL) {
            tl.add(() => {
                gsap.to([this._treeLockSprite, this._wildSpine], {
                    alpha: 1,
                    duration: durr
                });
                if (this._curMulti > 1) {
                    gsap.to(this._multiplier, {
                        alpha: 0,
                        duration: durr
                    });
                }
                this.resetStickyWildSpine();
                this.playWildAnimByName(WildSpinAnimName.IDLE_CANDLES, false, true);
            });
        }
        if (includeInTL) {
            tl.to([this._treeLockSprite, this._wildSpine], {
                alpha: 1,
                duration: durr
            }, 0);
            tl.to(this._multiplier, {
                alpha: 0,
                duration: durr
            }, 0);
            tl.add(() => {
                this.resetStickyWildSpine();
                this.playWildAnimByName(WildSpinAnimName.IDLE_CANDLES, false, true);
            })
        }
        return tl;
    }

    public showStickyWild(durr: number, includeInTL: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.isLocked = true;
                this.isVisible = true;
            }
        });
        if (this.isVisible) {
            return tl;
        }
        tl.add(() => {
            this.resetStickyWildSpine();
            this.playWildAnimByName(WildSpinAnimName.IDLE_CANDLES, false, true);
            if (!includeInTL) {
                gsap.to([this._treeLockSprite, this._wildSpine], {
                    alpha: 1,
                    duration: durr
                })
            }
        })
        if (includeInTL) {
            tl.to([this._treeLockSprite, this._wildSpine], {
                alpha: 1,
                duration: durr
            });
        }
        return tl;
    }

    public resetStickyWildAnimOnBet(): void {
        if (this._wildFireAnimTl && this._wildFireAnimTl.isActive()) {
            this._wildFireAnimTl.progress(1);
            this._wildFireAnimTl.kill();
            this._wildFireAnimTl = undefined;
        }
        this.resetStickyWildSpine();
        this.playWildAnimByName(WildSpinAnimName.IDLE_CANDLES, false, true);
    }

    public playWildEyesFireAnim(animName: WildSpinAnimName,isRestore:boolean=false): gsap.core.Timeline | undefined {
        const currentTrack = this._wildSpine.state.getCurrent(0);
        if ((currentTrack && currentTrack.animation.name === animName) ||
            (currentTrack && ((currentTrack.animation.name === WildSpinAnimName.IDLE_EYES_FIRE_LOOP_1 && animName === WildSpinAnimName.IDLE_EYES_FIRE_1) ||
                (currentTrack.animation.name === WildSpinAnimName.IDLE_EYES_FIRE_LOOP_2 && animName === WildSpinAnimName.IDLE_EYES_FIRE_2) ||
                (currentTrack.animation.name === WildSpinAnimName.IDLE_EYES_FIRE_LOOP_3 && animName === WildSpinAnimName.IDLE_EYES_FIRE_3)))
            || (!this.isVisible && this.isLocked)) {
            return undefined;
        }
        if (this._wildFireAnimTl && this._wildFireAnimTl.isActive()) {
            this._wildFireAnimTl.progress(1);
            this._wildFireAnimTl.kill();
            this._wildFireAnimTl = undefined;
        }
        this._wildFireAnimTl = gsap.timeline();
        if(!isRestore){
            this._wildFireAnimTl.add(SpineGSAPWrapper.createTimeline(this._wildSpine, 0, animName));
        }

        if (animName === WildSpinAnimName.IDLE_EYES_FIRE_1) {
            this._wildFireAnimTl.add(() => {
                SpineGSAPWrapper.createTimeline(this._wildSpine,0, WildSpinAnimName.IDLE_EYES_FIRE_LOOP_1,Number.MAX_VALUE);
            })
        } else if (animName === WildSpinAnimName.IDLE_EYES_FIRE_2) {
            this._wildFireAnimTl.add(() => {
                SpineGSAPWrapper.createTimeline(this._wildSpine,0, WildSpinAnimName.IDLE_EYES_FIRE_LOOP_2,Number.MAX_VALUE);
            })
        } else if (animName === WildSpinAnimName.IDLE_EYES_FIRE_3) {
            this._wildFireAnimTl.add(() => {
                SpineGSAPWrapper.createTimeline(this._wildSpine,0, WildSpinAnimName.IDLE_EYES_FIRE_LOOP_3,Number.MAX_VALUE);
            })
        }
        return this._wildFireAnimTl;
    }

    public playWildAnimByName(animName: WildSpinAnimName, includeInTl: boolean, loop: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (includeInTl) {
            tl.add(SpineGSAPWrapper.createTimeline(this._wildSpine, 0, animName, loop ? Number.MAX_VALUE : 0));
        } else {
            tl.add(() => {
                SpineGSAPWrapper.createTimeline(this._wildSpine, 0, animName, loop ? Number.MAX_VALUE : 0)
            })
        }

        return tl;
    }

    public playNoWinAnimation(durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._noWinOverlay, {duration: durr, alpha: 0.6}), "<");
        return tl;

    }

    public playAnimAfterNoWin(durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this._noWinOverlay, {duration: durr, alpha: 0}), "<");
        return tl;
    }

    private setMultiplier(value: number, setAlphaTrue: boolean = true): void {
        this._curMulti = value;
        this._multiplier.text = `${value}x`;
        if (setAlphaTrue && value > 1) {
            this._multiplier.alpha = 1;
        }
    }

    private treeLockSpriteOnCompCB(): void {
        this._treeLockSprite.alpha = 0;
        this._treeLockSprite.setFrame(0);
    }

    private resetStickyWildSpine(): void {
        this._wildSpine.state.setEmptyAnimation(0, 0)
        this._wildSpine.state.clearTracks();
        this._wildSpine.skeleton.setBonesToSetupPose();
        this._wildSpine.skeleton.setSlotsToSetupPose();

    }

    private createMultiplier(): PIXI.BitmapText {
        const multi: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: BS2GameAssets.BITMAP_FONT_MULTIPLIER_NUMBER,
            fontSize: 25,
            letterSpacing: -10
        });
        multi.position.set(-70, -13);
        multi.alpha = 0;
        multi.name = "_multi";
        return multi;
    }

    private createWinLineFlashTL(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            paused: true
        });
        tl.add(gsap.to(this._starOverlay, {duration: 0.05, alpha: 1, ease: "power1.out"}));
        tl.add(gsap.to(this._glowFrameOverlay, {duration: 0.05, alpha: 1, ease: "power1.out"}), "<");
        tl.add(gsap.to(this._starOverlay, {duration: 0.6, alpha: 0, ease: "power1.out"}));
        tl.add(gsap.to(this._glowFrameOverlay, {duration: 0.6, alpha: 0, ease: "power1.out"}), "<");
        return tl;
    }

    private createStarOverlay(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_HIGHLIGHT_OVERLAY)[0]);
        sprite.blendMode = PIXI.BLEND_MODES.ADD;
        sprite.tint = 0xa99a7c;//BS2Statics.symbolTints[this.symbolName];
        sprite.alpha = 0;
        sprite.anchor.set(0.5, 0.5);
        sprite.name = "overlay";
        return sprite;
    }

    private potentialWinAttentionTimeline(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            paused: true
        });
        tl.add(gsap.to(this._glowFrameOverlay, {duration: 0.05, alpha: 1, ease: "none"}));
        tl.add(gsap.to(this._glowFrameOverlay, {duration: 0.6, alpha: 0, ease: "none"}));
        return tl;
    }

    private createWildSymSpine(): PIXI.spine.Spine {
        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(BS2.assetLoader.getSpineAsset(BS2GameAssets.W_SPINE));
        spine.position.set(-3, -12.5);
        spine.height = BS2Statics.SYMBOL_HEIGHT;
        return spine;
    }

    private createTreeLockSprite(): TimelineSprite {
        const ts: TimelineSprite = new TimelineSprite(BS2.assetLoader.getTextures("bottomStickyWildLocker"));
        ts.anchor.set(0.5, 0.5);
        ts.position.set(2, -27);
        ts.name = "treeLock";
        return ts;
    }

    private setPosition(reelIdx: number): void {
        this.position.set(BS2Statics.SYMBOL_WIDTH * reelIdx, 0);
    }

    private createNoWinOverlay(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        sprite.tint = 0x000000;
        sprite.alpha = 0;
        sprite.anchor.set(0.5, 0.5);
        sprite.width = BS2Statics.SYMBOL_SPRITE_WIDTH;
        sprite.height = BS2Statics.SYMBOL_SPRITE_HEIGHT;
        sprite.name = "noWinOverlay";
        sprite.position = this._wildSpine.position;
        return sprite;
    }

    private createGlowFrameOverlay(): PIXI.Sprite {
        const frame: PIXI.Sprite = new PIXI.Sprite(BS2.assetLoader.getTextures(BS2GameAssets.SYMBOL_HIGHLIGHT_OVERLAY_FRAME)[0]);
        frame.blendMode = PIXI.BLEND_MODES.ADD;
        frame.tint = PIXI.utils.string2hex("#a99a7c");
        frame.alpha = 0;
        frame.anchor.set(0.5, 0.5);
        frame.height = BS2Statics.SYMBOL_HEIGHT;
        frame.width = BS2Statics.SYMBOL_WIDTH;
        frame.name = "overlayFrame";
        frame.position = this._wildSpine.position;
        return frame;
    }

    get isLocked(): boolean {
        return this._isLocked;
    }

    set isLocked(value: boolean) {
        this._isLocked = value;
    }

    get isVisible(): boolean {
        return this.visible;
    }

    set isVisible(value: boolean) {
        this.visible = value;
    }

}